"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.92 11.24a12.33 12.33 0 0 0-9-10.37 9.82 9.82 0 0 0-5.78 0A12.47 12.47 0 0 0 .36 9.75a11.88 11.88 0 0 0 3.16 11.38 2.5 2.5 0 0 0 3.08.36 1.5 1.5 0 0 0 .26-2.33l-.81-.81a1 1 0 0 1 0-1.42 1.1 1.1 0 0 1 1.6-.19c1.41 1.41 5.62 5.66 5.62 5.66a4 4 0 0 0 2.82 1.18 3.68 3.68 0 0 0 1.91-.53 12 12 0 0 0 5.92-11.81Zm-9.44 7.62a2.49 2.49 0 0 1 0-3.53 2.54 2.54 0 0 1 3.53 0 2.5 2.5 0 0 1-3.53 3.53ZM14.25 7.2a2 2 0 0 1 2-2 2 2 0 1 1-2 2Zm3.69 6a1.5 1.5 0 0 1 2.12-2.12 1.5 1.5 0 1 1-2.12 2.12Zm-6.29-8.48a2 2 0 1 1-2.83 0 2 2 0 0 1 2.83 0Z"
}), 'PaintingPalette');

exports.default = _default;